module.exports = __webpack_public_path__ + "static/media/pdf-download.b3805a55.png";